export const createImage = url =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', error => reject(error));
    image.src = url;
  });

export const fetchFileSize = async fileUrl => {
  const response = await fetch(fileUrl);
  if (!response.ok) throw new Error('Failed to fetch file.');
  const blob = await response.blob();
  return blob.size;
};

export default async function getCroppedImg(
  imageSrc,
  pixelCrop,
  reduceToKB = 80
) {
  const fileSizeInBytes = await fetchFileSize(imageSrc);
  const maxSizeBytes = reduceToKB * 1024;

  if (fileSizeInBytes <= maxSizeBytes) {
    const response = await fetch(imageSrc);
    return await response.blob();
  }

  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext('2d');

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  const reduceImageSize = (canvas, maxSizeKB) => {
    const maxBytes = maxSizeKB * 1024;
    let quality = 0.9;
    return new Promise((resolve, reject) => {
      const attemptToCompress = () => {
        canvas.toBlob(
          blob => {
            if (!blob) {
              reject(new Error('Compression failed.'));
              return;
            }
            if (blob.size <= maxBytes || quality <= 0.1) {
              resolve(blob);
            } else {
              quality -= 0.1;
              attemptToCompress();
            }
          },
          'image/jpeg',
          quality
        );
      };
      attemptToCompress();
    });
  };

  if (reduceToKB) {
    return reduceImageSize(canvas, reduceToKB);
  }

  return new Promise((resolve, reject) => {
    canvas.toBlob(file => {
      resolve(file);
    });
  });
}
